import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

const DISCOVER_PROVIDERS_PAGE_SIZE = 50;

// Safety cap mirrors fetchAllCasinoGamesTreeGroupPages: bound the loop so a BE
// that never flips has_next to false can't spin forever.
const MAX_PAGES = 200;

const extractItems = (payload) => {
  const items =
    payload?.data?.items ||
    payload?.data ||
    payload?.items ||
    [];
  return Array.isArray(items) ? items : [];
};

const fetchCasinoConfigurationDiscoverProviders = async () => {
  const token = JSON.parse(localStorage.getItem("token"));
  const privateInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  const items = [];
  let page = 1;
  let hasNext = true;

  while (hasNext && page <= MAX_PAGES) {
    const response = await privateInstance.get(
      API_ROUTES.DISCOVER_ADMIN_PROVIDERS,
      { params: { page, page_size: DISCOVER_PROVIDERS_PAGE_SIZE } },
    );

    const payload = response?.data;
    items.push(...extractItems(payload));

    // Defensive meta read (mirrors useCollectionProviders): if BE omits meta
    // or has_next on a page, treat it as the last page so the loop terminates
    // rather than spins.
    const meta = payload?.data?.meta;
    hasNext = Boolean(meta?.has_next);
    page += 1;
  }

  return items;
};

export const useCasinoConfigurationDiscoverProviders = (options = {}) => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: ["casinoConfiguration", "providers", "discover"],
    queryFn: fetchCasinoConfigurationDiscoverProviders,
    staleTime: 60 * 1000,
    enabled,
  });
};

export { fetchCasinoConfigurationDiscoverProviders };
